// MerchantB2B.jsx
import React, { useState } from "react";

const merchants = [
    {
        id: 13,
        name: "One World",
        logo: "/assets/partner/logo-oneworld.png",
        description:
            "aliansi maskapai penerbangan global yang terdiri dari 15 maskapai penerbangan. Aliansi ini didirikan pada 1 Februari 1999.",
    },
    {
        id: 14,
        name: "Global Hotel Alliance",
        logo: "/assets/partner/logo-global-hotel-alliance.png",
        description:
            " aliansi merek hotel terbesar di dunia. Berdasarkan model aliansi maskapai, didirikan pada tahun 2004 oleh empat jaringan hotel, Kempinski, Pan Pacific Hotels and Resorts, Rydges Hotels & Resorts, dan Wyndham International.",
    }    
];

export default function MerchantB2B() {
    const [selected, setSelected] = useState(null);

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 text-center">
                <h2 className="text-3xl font-bold mb-6 text-gray-800">
                    Merchant & B2B Integration
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto mb-10">
                    We collaborate with various institutions and agencies to
                    supporting digital transformation in various business sectors. Click on the logo to view
                    explanation of integration and its benefits.
                </p>

                {/* Grid of Partners */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
                    {merchants.map((m) => (
                        <button
                            key={m.id}
                            onClick={() => setSelected(m)}
                            className="flex flex-col items-center justify-center p-4 bg-white border rounded-xl hover:shadow-lg transition"
                        >
                            <img
                                src={m.logo}
                                alt={m.name}
                                className="h-28 object-contain mb-3"
                            />
                            <span className="text-sm font-medium text-gray-700 mt-2">
                                {m.name}
                            </span>
                        </button>
                    ))}
                </div>
            </div>

            {/* Modal */}
            {selected && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white max-w-md w-full mx-4 rounded-xl shadow-lg p-6 relative animate-fade-in">
                        <button
                            onClick={() => setSelected(null)}
                            className="absolute top-3 right-4 text-gray-600 hover:text-gray-900 text-2xl"
                        >
                            ✕
                        </button>
                        <div className="flex flex-col items-center text-center">
                            <img
                                src={selected.logo}
                                alt={selected.name}
                                className="h-28 mb-4"
                            />
                            <h3 className="text-xl font-semibold text-gray-800 mb-2">
                                {selected.name}
                            </h3>
                            <p className="text-gray-600">{selected.description}</p>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
